import './init';

import React from 'react';
import { render } from 'react-dom';
import Root from './pages/Root';
import { history, store } from './store/configureStore';
import './styles/styles.scss';
// @ts-ignore
import { registerSW } from 'virtual:pwa-register';

if ('serviceWorker' in navigator) {
  const updateSW = registerSW({
    immediate: true,
    onNeedRefresh() {
      const shouldUpdate = confirm('A new version is available. Reload now?');
      if (shouldUpdate) {
        updateSW(true);
      }
    },
    onOfflineReady() {
      console.log('App is ready to work offline');
    }
  });
}

export type RootState = ReturnType<typeof store.getState>;

render(<Root store={store} history={history} />, document.getElementById('app'));
